import { Parser } from "@siteimprove/alfa-parser";
import { Refinement } from "@siteimprove/alfa-refinement";
import { Simple } from "../../index.js";
import { Compound } from "../../compound.js";
import { Active } from "./active.js";
import { AnyLink } from "./any-link.js";
import { Checked } from "./checked.js";
import { Disabled } from "./disabled.js";
import { Empty } from "./empty.js";
import { Enabled } from "./enabled.js";
import { FirstChild } from "./first-child.js";
import { FirstOfType } from "./first-of-type.js";
import { Focus } from "./focus.js";
import { FocusVisible } from "./focus-visible.js";
import { FocusWithin } from "./focus-within.js";
import { Has } from "./has.js";
import { Host } from "./host.js";
import { HostContext } from "./host-context.js";
import { Hover } from "./hover.js";
import { Is } from "./is.js";
import { LastChild } from "./last-child.js";
import { LastOfType } from "./last-of-type.js";
import { Link } from "./link.js";
import { Not } from "./not.js";
import { NthChild } from "./nth-child.js";
import { NthLastChild } from "./nth-last-child.js";
import { NthLastOfType } from "./nth-last-of-type.js";
import { NthOfType } from "./nth-of-type.js";
import { OnlyChild } from "./only-child.js";
import { OnlyOfType } from "./only-of-type.js";
import { Root } from "./root.js";
import { Visited } from "./visited.js";
import { Where } from "./where.js";
import { PseudoClassSelector } from "./pseudo-class.js";
const { either, filter } = Parser;
const { or } = Refinement;
/**
 * @public
 */
export var PseudoClass;
(function (PseudoClass) {
    function isPseudoClass(value) {
        // Note: this is not totally true as we could extend PseudoClassSelector
        // without making it a PseudoClass. We're likely having other problems in
        // that case…
        return value instanceof PseudoClassSelector;
    }
    PseudoClass.isPseudoClass = isPseudoClass;
    PseudoClass.isHost = Host.isHost;
    function parse(parseSelector) {
        return either(Active.parse, AnyLink.parse, Checked.parse, Disabled.parse, Empty.parse, Enabled.parse, FirstChild.parse, FirstOfType.parse, Focus.parse, FocusVisible.parse, FocusWithin.parse, Host.parse(() => filter(parseSelector(), or(Compound.isCompound, Simple.isSimple), () => ":host() only accepts compound selectors")), HostContext.parse(() => filter(parseSelector(), or(Compound.isCompound, Simple.isSimple), () => ":host-context() only accepts compound selectors")), Hover.parse, LastChild.parse, LastOfType.parse, Link.parse, OnlyChild.parse, OnlyOfType.parse, Root.parse, Visited.parse, NthChild.parse(parseSelector), NthLastChild.parse(parseSelector), NthLastOfType.parse, NthOfType.parse, Has.parse(parseSelector), Is.parse(parseSelector), Not.parse(parseSelector), Where.parse(parseSelector));
    }
    PseudoClass.parse = parse;
})(PseudoClass || (PseudoClass = {}));
//# sourceMappingURL=index.js.map